import { render, staticRenderFns } from "./pros-and-cons.vue?vue&type=template&id=f61d4520&"
import script from "./pros-and-cons.vue?vue&type=script&lang=js&"
export * from "./pros-and-cons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports